import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, error, className, id, ...rest },
  ref,
) {
  const inputId = id || rest.name || undefined;
  return (
    <div className="space-y-1.5">
      {label && (
        <label htmlFor={inputId} className="block text-xs font-medium text-fg-muted">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={cn(
          'block w-full h-11 px-3.5 rounded-lg',
          'bg-bg-elevated border border-border text-sm text-fg placeholder:text-fg-subtle',
          'transition-colors duration-150',
          'focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/30',
          error && 'border-bear focus:border-bear focus:ring-bear/30',
          className,
        )}
        {...rest}
      />
      {hint && !error && <p className="text-2xs text-fg-subtle">{hint}</p>}
      {error && <p className="text-2xs text-bear">{error}</p>}
    </div>
  );
});
